import { toast } from 'react-toastify'
import { alertConstants } from './alertConstants'

export function alert(state = {}, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      toast.success(action.message)
      return {}
    case alertConstants.ERROR:
      toast.error(action.message)
      return {}
    case alertConstants.CLEAR:
      return {}
    default:
      return {}
  }
}
